import {put} from "redux-saga/effects";

import axios from "../../../../../api/axios"

import * as actions from "../../../../actions";
import * as api from "../../../../../api";

export function* guestExplorerOffresFetchListeOffresSaga(action) {


    yield put(actions.guestExplorerOffresFetchListeOffresStart());

    try {
        const response = yield axios.get(api.getListeOffres);
        const listeOffres = yield response.data;
        yield put(actions.guestExplorerOffresFetchListeOffresSuccess(listeOffres));
    } catch (error) {
        if(error.response) {
            yield put(actions.guestExplorerOffresFetchListeOffresFail(error.response.data.error));
        }else {
            yield put(actions.guestExplorerOffresFetchListeOffresFail("There's an error!"));
        }
    }
}